import * as Sentry from '@sentry/react';

const getNonEmptyString = (value: unknown): string | undefined => {
	if (typeof value !== 'string') {
		return undefined;
	}

	const trimmed = value.trim();
	return trimmed.length > 0 ? trimmed : undefined;
};

export const initSentry = (): void => {
	const dsn = getNonEmptyString(import.meta.env.VITE_SENTRY_DSN);
	const environment =
		getNonEmptyString(import.meta.env.VITE_SENTRY_ENVIRONMENT) ??
		getNonEmptyString(__SENTRY_ENVIRONMENT_FROM_BUILD__) ??
		(import.meta.env.PROD ? 'production' : undefined);
	const release =
		getNonEmptyString(import.meta.env.VITE_SENTRY_RELEASE) ??
		getNonEmptyString(__SENTRY_RELEASE_FROM_BUILD__);

	if (!dsn) {
		// A missing monitoring setting must never stop the app from loading.
		if (import.meta.env.PROD) {
			console.warn('[Sentry] VITE_SENTRY_DSN is not set; error reporting is disabled.');
		}
		return;
	}

	Sentry.init({
		dsn,
		environment,
		release,
		// Placeholder sampling values: tune these for your production traffic goals.
		tracesSampleRate: 0,
	});
};
